import { SyntheticEvent } from 'react';
import { TableBodyColumn } from 'ui/components/table';
import TableBodyRow from 'ui/components/table/TableBodyRow';
import { EditButton, RemoveButton } from 'dashboard/components/table/buttons';
import { ConsumerUnit } from 'consumerUnits/model/consumerUnit';

type Props = {
  consumerUnit: ConsumerUnit;
  onClickEditButton: (id: number) => void;
  onClickRemoveButton: (id: number) => void;
  disableEditButton: boolean;
  disableRemoveButton: boolean;
};

export default function ConsumersTableItem({
  consumerUnit: {
    id,
    consumerUnitAddressState,
    consumerUnitPowerDistributionUnitIdentifier,
    consumerUnitConsumptionGroupType,
    powerDistributionUnit: { powerDistributionUnitLegalName },
    cooperativeMember: { cooperativeMemberLegalName },
    cooperative: { cooperativeLegalName },
  },
  onClickEditButton,
  onClickRemoveButton,
  disableEditButton,
  disableRemoveButton,
}: Props) {
  const handleClickEditButton = (e: SyntheticEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();

    onClickEditButton(id);
  };

  const handleClickRemoveButton = (e: SyntheticEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();

    onClickRemoveButton(id);
  };

  const formattedPowerDistributionUnitLegalName =
    powerDistributionUnitLegalName.slice(0, 15);

  return (
    <TableBodyRow dataTestId={`consumer-unit-row-id-${id}`}>
      <TableBodyColumn>
        {consumerUnitPowerDistributionUnitIdentifier}
      </TableBodyColumn>
      <TableBodyColumn>{cooperativeMemberLegalName}</TableBodyColumn>
      <TableBodyColumn>{cooperativeLegalName}</TableBodyColumn>
      <TableBodyColumn className="text-center"> - </TableBodyColumn>
      <TableBodyColumn className="font-bold">
        {formattedPowerDistributionUnitLegalName}...
      </TableBodyColumn>
      <TableBodyColumn>{consumerUnitAddressState}</TableBodyColumn>
      <TableBodyColumn className="text-center font-bold">
        {consumerUnitConsumptionGroupType}
      </TableBodyColumn>
      <TableBodyColumn className="text-center"> - </TableBodyColumn>
      <TableBodyColumn className="flex gap-x-3 items-end justify-end">
        <EditButton onClick={handleClickEditButton} disabled={disableEditButton} />
        <RemoveButton
          onClick={handleClickRemoveButton}
          disabled={disableRemoveButton}
        />
      </TableBodyColumn>
    </TableBodyRow>
  );
}
